<template>
	<footer class="footer">
		<div class="container">
			<div class="copyright text-center">&copy; {{ new Date().getFullYear() }} Gerenciador, desenvolvido por <a href="https://espressolabs.com.br" rel="noopener noreferrer" target="_blank">Espresso Labs</a></div>
		</div>
	</footer>
</template>
<script>
export default {};
</script>
<style></style>
